import React, { Component } from 'react';

import CustomDialog from './modalDialog';
import { ModalContainer } from 'react-modal-dialog';
import PropTypes from 'prop-types';
import _ from 'lodash';

const targetWidth = 500;

export const ModalBody = ({ handleClose, header, children }) => {
  const windowWidth = window.innerWidth;
  return (
    <ModalContainer onClose={handleClose}>
      <CustomDialog
        margin={0}
        width={windowWidth <= targetWidth ? windowWidth - 10 : targetWidth}
        recenter={true}
      >
        {header !== `` && (
          <div className="modal__header">
            <a
              id="t-closeModal"
              className="modal__close"
              onClick={() => handleClose()}
            >{` `}</a>
            <h2 id={`t-modalHeader_${_.snakeCase(header)}`}>{header}</h2>
          </div>
        )}
        <div id="t-modalContent" className="modal__content mb50">
          {children}
        </div>
      </CustomDialog>
    </ModalContainer>
  );
};

class Modal extends Component {
  constructor(props) {
    super(props);
    this.state = { isShowingModal: props.isShowingModal };
  }

  componentWillReceiveProps(nextProps) {
    if (
      _.has(this.props, `handleClose`) &&
      this.state.isShowingModal !== nextProps.isShowingModal
    ) {
      this.setState({ isShowingModal: nextProps.isShowingModal });
    }
  }

  handleClose = () => {
    // if we're handling the state of the modal outside of the component
    if (_.has(this.props, `handleClose`)) {
      this.props.handleClose();
    } else {
      this.setState({ isShowingModal: false });
    }
  };

  modalBody = () => {
    return (
      this.state.isShowingModal && (
        <ModalBody handleClose={this.handleClose} header={this.props.header}>
          {this.props.children}
        </ModalBody>
      )
    );
  };

  render() {
    const { label, style } = this.props;
    return label !== `` ? (
      <span
        style={style}
        onClick={() => this.setState({ isShowingModal: true })}
      >
        {label}
        {this.modalBody()}
      </span>
    ) : (
      this.modalBody()
    );
  }
}

Modal.defaultProps = { label: ``, isShowingModal: false, style: {} };

Modal.propTypes = {
  label: PropTypes.oneOfType([PropTypes.element, PropTypes.string]),
  header: PropTypes.string.isRequired,
  children: PropTypes.oneOfType([
    PropTypes.element,
    PropTypes.string,
    PropTypes.array,
  ]).isRequired,
};

export default Modal;



// WEBPACK FOOTER //
// ./src/components/modal.js